<div class="banner">
  <quota-banner [hideTrialBanner]="true" [hideExpiredBanner]="true"></quota-banner>
</div>

<div class="container-fluid work-replay-page">
  <div class="wr-page-header">
    <h1 class="wr-page-title">Work Replay</h1>
    <p class="wr-page-subtitle">Review screenshots with timeline, app usage, and activity context.</p>
  </div>

  <mat-card class="wr-main-card fluid-ss">
    <div class="wr-filter-bar">
      <div class="wr-filter-header">
        <div class="wr-filter-title-group">
          <mat-icon class="wr-filter-icon">filter_list</mat-icon>
          <span class="wr-filter-title">Filters</span>
        </div>
        <div class="wr-filter-header-right">
          <button mat-stroked-button type="button" class="wr-filter-toggle-btn" (click)="toggleFiltersCollapsed()"
            [attr.aria-expanded]="!filtersCollapsed" aria-controls="wr-filter-controls">
            <mat-icon class="wr-filter-toggle-ic" fontSet="material-symbols-outlined">
              {{ filtersCollapsed ? 'expand_more' : 'expand_less' }}
            </mat-icon>
            <span>{{ filtersCollapsed ? 'Show filters' : 'Hide filters' }}</span>
          </button>
          <span class="wr-filter-loading" *ngIf="loadingScreenshots && !isLanding">Loading…</span>
          <div class="wr-filter-count"
            *ngIf="!isLanding && !loadingScreenshots && (filteredScreenshots.length > 0 || (showConductLogsCtrl.value && conductActivityFilterCtrl.value === 'untracked' && untrackedSlotsCount > 0))">
            <span class="wr-count-badge" *ngIf="conductActivityFilterCtrl.value !== 'untracked'">
              {{ filteredScreenshots.length }} screenshot{{ filteredScreenshots.length !== 1 ? 's' : '' }}
            </span>
            <span class="wr-count-badge" *ngIf="conductActivityFilterCtrl.value === 'untracked'">
              {{ untrackedSlotsCount }} untracked slot{{ untrackedSlotsCount !== 1 ? 's' : '' }}
            </span>
          </div>
        </div>
      </div>

      <div class="wr-filter-controls" id="wr-filter-controls" *ngIf="!filtersCollapsed">
        <div class="wr-filter-row wr-filter-row--primary" [class.wr-filter-row--primary-loaded]="!isLanding">
          <div class="wr-filter-item wr-filter-item--employee">
            <label class="wr-filter-label">
              <mat-icon class="wr-label-icon">people</mat-icon>
              <span>Employee</span>
            </label>
            <app-employee-search [userList]="employees" [placeholder]="'Select Employee'" [isShowAllEmp]="false"
              class="wr-employee-search w-full h-full" [selectedEmployeeId]="userId || ''"
              [selectedEmployeeLabel]="selectedEmployeeName" (employeeSelected)="onEmployeeSelected($event)">
            </app-employee-search>
            <div class="wr-employee-inline-actions" *ngIf="employeesLoadError">
              <span class="wr-field-error">{{ employeesLoadError }}</span>
              <button mat-button type="button" color="primary" (click)="retryLoadEmployees()">Retry</button>
            </div>
          </div>

          <div class="wr-filter-item wr-filter-item--date">
            <label class="wr-filter-label" id="wr-date-filter-cap">
              <mat-icon class="wr-label-icon">event</mat-icon>
              <span>Date</span>
              <span *ngIf="isWorkReplayDateNavigationLocked()" class="wr-date-lock material-symbols-outlined"
                matTooltip="Professional — full Work Replay history" matTooltipPosition="above"
                aria-hidden="true">lock</span>
            </label>
            <div class="wr-date-nav" [class.wr-date-nav--locked]="isWorkReplayDateNavigationLocked()">
              <button type="button" class="wr-daynav-btn"
                [class.wr-daynav-btn--locked]="isWorkReplayDateNavigationLocked()" (click)="prevDay()"
                [disabled]="!isWorkReplayDateNavigationLocked() && !canGoPrevDay" title="Previous day"
                aria-label="Previous day">
                <span class="material-symbols-outlined">chevron_left</span>
              </button>
              <mat-form-field appearance="outline" class="wr-input-wrap wr-date" subscriptSizing="dynamic">
                <input matInput [matDatepicker]="picker" [min]="minDate" [max]="maxDate" [value]="selectedDate"
                  [readonly]="isWorkReplayDateNavigationLocked()" aria-labelledby="wr-date-filter-cap"
                  (dateChange)="onDateChanged($event.value)" />
                <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                <mat-datepicker #picker (opened)="onDatepickerOpened()"></mat-datepicker>
              </mat-form-field>
              <button type="button" class="wr-daynav-btn"
                [class.wr-daynav-btn--locked]="isWorkReplayDateNavigationLocked()" (click)="nextDay()"
                [disabled]="!isWorkReplayDateNavigationLocked() && !canGoNextDay" title="Next day"
                aria-label="Next day">
                <span class="material-symbols-outlined">chevron_right</span>
              </button>
            </div>
          </div>

          <div class="wr-filter-item wr-filter-item--daypart" *ngIf="!isLanding">
            <label class="wr-filter-label">
              <mat-icon class="wr-label-icon" fontSet="material-symbols-outlined">wb_twilight</mat-icon>
              <span>Time of day</span>
            </label>
            <mat-form-field appearance="outline" class="wr-input-wrap wr-filter wr-daypart-filter-field"
              subscriptSizing="dynamic">
              <mat-select [formControl]="daypartFilterCtrl" panelClass="wr-daypart-filter-panel" multiple
                placeholder="All times">
                <mat-select-trigger>
                  <span class="wr-app-option-row wr-app-select-trigger-row">
                    <mat-icon class="wr-app-option-ic" fontSet="material-symbols-outlined">{{
                      matIconForDaypartFilter(daypartFilterTriggerIcon) }}</mat-icon>
                    <span class="wr-app-option-label">{{ daypartFilterTriggerLabel }}</span>
                  </span>
                </mat-select-trigger>
                <mat-option *ngFor="let part of daypartFilterOptions" [value]="part" class="wr-daypart-filter-option">
                  <span class="wr-app-option-row">
                    <mat-icon class="wr-app-option-ic" fontSet="material-symbols-outlined">{{
                      matIconForDaypartFilter(part) }}</mat-icon>
                    <span class="wr-app-option-label">{{ part }}</span>
                  </span>
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>

        <ng-container *ngIf="!isLanding">
          <div class="wr-filter-row wr-filter-row--secondary">
            <!-- 1. App Filter -->
            <div class="wr-filter-item">
              <label class="wr-filter-label">
                <mat-icon class="wr-label-icon" fontSet="material-symbols-outlined">apps</mat-icon>
                <span>App</span>
              </label>
              <mat-form-field appearance="outline" class="wr-input-wrap wr-filter wr-app-filter-field"
                subscriptSizing="dynamic">
                <mat-select [formControl]="appFilterCtrl" panelClass="wr-app-filter-panel">
                  <mat-select-trigger>
                    <span class="wr-app-option-row wr-app-select-trigger-row">
                      <mat-icon class="wr-app-option-ic" fontSet="material-symbols-outlined">
                        {{ ({ app_name: appFilterTriggerLabel }) | appIconGlyph }}
                      </mat-icon>
                      <span class="wr-app-option-label">{{ appFilterTriggerLabel }}</span>
                    </span>
                  </mat-select-trigger>
                  <mat-option value="all" class="wr-app-filter-option">
                    <span class="wr-app-option-row">
                      <mat-icon class="wr-app-option-ic" fontSet="material-symbols-outlined">widgets</mat-icon>
                      <span class="wr-app-option-label">All apps</span>
                    </span>
                  </mat-option>
                  <mat-option *ngFor="let app of availableApps" [value]="app.toLowerCase()"
                    class="wr-app-filter-option">
                    <span class="wr-app-option-row">
                      <mat-icon class="wr-app-option-ic" fontSet="material-symbols-outlined">{{ { app_name: app } |
                        appIconGlyph }}</mat-icon>
                      <span class="wr-app-option-label">{{ app }}</span>
                    </span>
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>

            <!-- 2. Type Filter -->
            <div class="wr-filter-item">
              <label class="wr-filter-label">
                <mat-icon class="wr-label-icon" fontSet="material-symbols-outlined">category</mat-icon>
                <span>Type</span>
              </label>
              <mat-form-field appearance="outline" class="wr-input-wrap wr-filter wr-type-filter-field"
                subscriptSizing="dynamic">
                <mat-select [formControl]="typeFilterCtrl" panelClass="wr-type-filter-panel">
                  <mat-select-trigger>
                    <span class="wr-app-option-row wr-app-select-trigger-row">
                      <mat-icon class="wr-app-option-ic" fontSet="material-symbols-outlined">{{
                        matIconForTypeFilter(typeFilterCtrl.value) }}</mat-icon>
                      <span class="wr-app-option-label">{{ typeFilterTriggerLabel }}</span>
                    </span>
                  </mat-select-trigger>
                  <mat-option value="all" class="wr-type-filter-option">
                    <span class="wr-app-option-row">
                      <mat-icon class="wr-app-option-ic" fontSet="material-symbols-outlined">{{
                        matIconForTypeFilter('all') }}</mat-icon>
                      <span class="wr-app-option-label">All types</span>
                    </span>
                  </mat-option>
                  <mat-option value="periodic" class="wr-type-filter-option">
                    <span class="wr-app-option-row">
                      <mat-icon class="wr-app-option-ic" fontSet="material-symbols-outlined">{{
                        matIconForTypeFilter('periodic') }}</mat-icon>
                      <span class="wr-app-option-label">Periodic</span>
                    </span>
                  </mat-option>
                  <mat-option value="app-changed" class="wr-type-filter-option">
                    <span class="wr-app-option-row">
                      <mat-icon class="wr-app-option-ic" fontSet="material-symbols-outlined">{{
                        matIconForTypeFilter('app-changed') }}</mat-icon>
                      <span class="wr-app-option-label">App Switch</span>
                    </span>
                  </mat-option>
                  <mat-option value="admin-request" class="wr-type-filter-option">
                    <span class="wr-app-option-row">
                      <mat-icon class="wr-app-option-ic" fontSet="material-symbols-outlined">{{
                        matIconForTypeFilter('admin-request') }}</mat-icon>
                      <span class="wr-app-option-label">On Demand</span>
                    </span>
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>

            <!-- 3. Bucket Size Filter -->
            <div class="wr-filter-item">
              <label class="wr-filter-label">
                <mat-icon class="wr-label-icon" fontSet="material-symbols-outlined">view_timeline</mat-icon>
                <span>Bucket size</span>
              </label>
              <mat-form-field appearance="outline" class="wr-input-wrap wr-filter wr-bucket-filter-field"
                subscriptSizing="dynamic">
                <mat-select [value]="bucketSize" (selectionChange)="setBucketSize($event.value)"
                  panelClass="wr-bucket-filter-panel">
                  <mat-select-trigger>
                    <span class="wr-app-option-row wr-app-select-trigger-row">
                      <mat-icon class="wr-app-option-ic" fontSet="material-symbols-outlined">{{
                        matIconForBucketSize(bucketSize) }}</mat-icon>
                      <span class="wr-app-option-label">{{ bucketSizeTriggerLabel }}</span>
                    </span>
                  </mat-select-trigger>
                  <mat-option [value]="15" class="wr-bucket-filter-option">
                    <span class="wr-app-option-row">
                      <mat-icon class="wr-app-option-ic" fontSet="material-symbols-outlined">{{ matIconForBucketSize(15)
                        }}</mat-icon>
                      <span class="wr-app-option-label">15 min</span>
                    </span>
                  </mat-option>
                  <mat-option [value]="30" class="wr-bucket-filter-option">
                    <span class="wr-app-option-row">
                      <mat-icon class="wr-app-option-ic" fontSet="material-symbols-outlined">{{ matIconForBucketSize(30)
                        }}</mat-icon>
                      <span class="wr-app-option-label">30 min</span>
                    </span>
                  </mat-option>
                  <mat-option [value]="60" class="wr-bucket-filter-option">
                    <span class="wr-app-option-row">
                      <mat-icon class="wr-app-option-ic" fontSet="material-symbols-outlined">{{ matIconForBucketSize(60)
                        }}</mat-icon>
                      <span class="wr-app-option-label">1 hour</span>
                    </span>
                  </mat-option>
                  <mat-option [value]="120" class="wr-bucket-filter-option">
                    <span class="wr-app-option-row">
                      <mat-icon class="wr-app-option-ic" fontSet="material-symbols-outlined">{{
                        matIconForBucketSize(120) }}</mat-icon>
                      <span class="wr-app-option-label">2 hours</span>
                    </span>
                  </mat-option>
                  <mat-option [value]="240" class="wr-bucket-filter-option">
                    <span class="wr-app-option-row">
                      <mat-icon class="wr-app-option-ic" fontSet="material-symbols-outlined">{{
                        matIconForBucketSize(240) }}</mat-icon>
                      <span class="wr-app-option-label">4 hours</span>
                    </span>
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>

            <!-- 4. Conduct Activity Filter (Tracked vs Untracked) -->
            <div class="wr-filter-item" *ngIf="showConductLogsCtrl.value">
              <label class="wr-filter-label">
                <mat-icon class="wr-label-icon" fontSet="material-symbols-outlined">browse_activity</mat-icon>
                <span>Activity</span>
              </label>
              <mat-form-field appearance="outline" class="wr-input-wrap wr-filter wr-activity-filter-field"
                subscriptSizing="dynamic">
                <mat-select [formControl]="conductActivityFilterCtrl" panelClass="wr-activity-filter-panel">
                  <mat-select-trigger>
                    <span class="wr-app-option-row wr-app-select-trigger-row">
                      <mat-icon class="wr-app-option-ic" fontSet="material-symbols-outlined">{{
                        matIconForActivityFilter(conductActivityFilterCtrl.value) }}</mat-icon>
                      <span class="wr-app-option-label">{{ conductActivityFilterTriggerLabel }}</span>
                    </span>
                  </mat-select-trigger>
                  <mat-option value="all" class="wr-activity-filter-option">
                    <span class="wr-app-option-row">
                      <mat-icon class="wr-app-option-ic" fontSet="material-symbols-outlined">browse_activity</mat-icon>
                      <span class="wr-app-option-label">All activity</span>
                    </span>
                  </mat-option>
                  <mat-option value="tracked" class="wr-activity-filter-option"
                    matTooltip="Conduct timelogs with captured screenshots">
                    <span class="wr-app-option-row">
                      <mat-icon class="wr-app-option-ic" fontSet="material-symbols-outlined">task_alt</mat-icon>
                      <span class="wr-app-option-label">Tracked activity</span>
                    </span>
                  </mat-option>
                  <mat-option value="untracked" class="wr-activity-filter-option"
                    matTooltip="Conduct timelogs without captured screenshots">
                    <span class="wr-app-option-row">
                      <mat-icon class="wr-app-option-ic" fontSet="material-symbols-outlined">pending_actions</mat-icon>
                      <span class="wr-app-option-label">Untracked activity</span>
                    </span>
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>

            <!-- 5. Conduct Project Filter (Last Filter) -->
            <div class="wr-filter-item" *ngIf="showConductLogsCtrl.value">
              <label class="wr-filter-label">
                <mat-icon class="wr-label-icon" fontSet="material-symbols-outlined">folder</mat-icon>
                <span>Project</span>
              </label>
              <mat-form-field appearance="outline" class="wr-input-wrap wr-filter wr-project-filter-field"
                subscriptSizing="dynamic">
                <mat-select [formControl]="projectFilterCtrl" panelClass="wr-project-filter-panel">
                  <mat-select-trigger>
                    <span class="wr-app-option-row wr-app-select-trigger-row">
                      <mat-icon class="wr-app-option-ic" fontSet="material-symbols-outlined">folder</mat-icon>
                      <span class="wr-app-option-label">{{ projectFilterTriggerLabel }}</span>
                    </span>
                  </mat-select-trigger>
                  <mat-option value="all" class="wr-project-filter-option">
                    <span class="wr-app-option-row">
                      <mat-icon class="wr-app-option-ic" fontSet="material-symbols-outlined">folder_open</mat-icon>
                      <span class="wr-app-option-label">All projects</span>
                    </span>
                  </mat-option>
                  <mat-option *ngFor="let proj of availableProjects" [value]="proj.name.toLowerCase()"
                    class="wr-project-filter-option">
                    <span class="wr-app-option-row">
                      <mat-icon class="wr-app-option-ic" fontSet="material-symbols-outlined">folder</mat-icon>
                      <span class="wr-app-option-label">{{ proj.name }} ({{ proj.totalHours }})</span>
                    </span>
                  </mat-option>
                  <mat-option *ngIf="availableProjects.length === 0" [disabled]="true" class="wr-project-filter-option">
                    <span class="wr-app-option-row wr-muted">
                      <span class="wr-app-option-label">No projects found</span>
                    </span>
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>
          </div>

          <div class="wr-filter-row wr-filter-row--options">
            <div class="wr-checkbox-group">
              <mat-checkbox class="wr-empty-slots-checkbox" color="primary" [formControl]="showEmptySlotsCtrl"
                matTooltip="When enabled, shows the full day (12:00 AM–11:59 PM) including time slots with no screenshots—empty slots and tracked usage without captures."
                matTooltipShowDelay="350">
                Show time slots with no screenshots
              </mat-checkbox>

            </div>
            <button *ngIf="hasActiveFilters" mat-stroked-button type="button" class="wr-clear-filters-btn"
              color="primary" (click)="clearReplayFilters()">
              Clear filters
            </button>
          </div>
        </ng-container>
      </div>

      <div class="wr-filter-collapsed-summary" *ngIf="filtersCollapsed" role="status" aria-live="polite">
        <div class="wr-collapsed-chip">
          <mat-icon class="wr-collapsed-chip-ic">people</mat-icon>
          <span class="wr-collapsed-chip-key">Employee:</span>
          <span class="wr-collapsed-chip-value">{{ selectedEmployeeName || 'Not selected' }}</span>
          <span *ngIf="showRustAgentBetaBadge" class="agent-beta-badge agent-beta-badge--name"
            [matTooltip]="sysConfig.rustAgentNameBadgeTooltip" matTooltipPosition="below">{{
            sysConfig.rustAgentBetaBadge }}</span>
        </div>
        <div class="wr-collapsed-chip">
          <mat-icon class="wr-collapsed-chip-ic">event</mat-icon>
          <span class="wr-collapsed-chip-key">Date:</span>
          <span class="wr-collapsed-chip-value">{{ selectedDate ? (selectedDate | date:'MMM d, y') : 'Not set' }}</span>
        </div>
        <div class="wr-collapsed-chip" *ngIf="!isLanding">
          <mat-icon class="wr-collapsed-chip-ic" fontSet="material-symbols-outlined">wb_twilight</mat-icon>
          <span class="wr-collapsed-chip-key">Time:</span>
          <span class="wr-collapsed-chip-value">{{ daypartFilterTriggerLabel }}</span>
        </div>
        <div class="wr-collapsed-chip" *ngIf="!isLanding">
          <mat-icon class="wr-collapsed-chip-ic" fontSet="material-symbols-outlined">apps</mat-icon>
          <span class="wr-collapsed-chip-key">App:</span>
          <span class="wr-collapsed-chip-value">{{ appFilterTriggerLabel }}</span>
        </div>
        <div class="wr-collapsed-chip" *ngIf="!isLanding">
          <mat-icon class="wr-collapsed-chip-ic" fontSet="material-symbols-outlined">category</mat-icon>
          <span class="wr-collapsed-chip-key">Type:</span>
          <span class="wr-collapsed-chip-value">{{ typeFilterTriggerLabel }}</span>
        </div>
        <div class="wr-collapsed-chip" *ngIf="!isLanding">
          <mat-icon class="wr-collapsed-chip-ic" fontSet="material-symbols-outlined">view_timeline</mat-icon>
          <span class="wr-collapsed-chip-key">Bucket:</span>
          <span class="wr-collapsed-chip-value">{{ bucketSizeTriggerLabel }}</span>
        </div>
        <div class="wr-collapsed-chip"
          *ngIf="!isLanding && showConductLogsCtrl.value && (conductActivityFilterCtrl.value || 'all') !== 'all'">
          <mat-icon class="wr-collapsed-chip-ic" fontSet="material-symbols-outlined">{{
            matIconForActivityFilter(conductActivityFilterCtrl.value) }}</mat-icon>
          <span class="wr-collapsed-chip-key">Activity:</span>
          <span class="wr-collapsed-chip-value">{{ conductActivityFilterTriggerLabel }}</span>
        </div>
        <div class="wr-collapsed-chip"
          *ngIf="!isLanding && showConductLogsCtrl.value && (projectFilterCtrl.value || 'all') !== 'all'">
          <mat-icon class="wr-collapsed-chip-ic" fontSet="material-symbols-outlined">folder</mat-icon>
          <span class="wr-collapsed-chip-key">Project:</span>
          <span class="wr-collapsed-chip-value">{{ projectFilterTriggerLabel }}</span>
        </div>
      </div>
    </div>

    <div class="wr-context-hint" *ngIf="!isLanding && selectedEmployeeName" role="note">
      <mat-icon class="wr-hint-icon" fontSet="material-symbols-outlined">person</mat-icon>
      <div class="wr-hint-text">
        <span class="wr-hint-strong">{{ selectedEmployeeName }}</span>
        <span *ngIf="showRustAgentBetaBadge" class="agent-beta-badge agent-beta-badge--name"
          [matTooltip]="sysConfig.rustAgentNameBadgeTooltip" matTooltipPosition="below">{{ sysConfig.rustAgentBetaBadge
          }}</span>
        <span class="wr-hint-sep">·</span>
        <span>{{ selectedDate | date:'EEEE, MMMM d, y' }}</span>
        <ng-container *ngIf="shiftContextReady">
          <span class="wr-hint-sep">·</span>
          <span *ngIf="shiftHoursSummary; else shiftNotAssigned">{{ shiftHoursSummary }}</span>
          <ng-template #shiftNotAssigned>
            <span class="wr-hint-muted">Shift not assigned</span>
          </ng-template>
        </ng-container>
      </div>
    </div>

    <div class="wr-context-hint wr-timezone-hint" *ngIf="!isLanding && regionHint" role="note">
      <mat-icon class="wr-hint-icon" fontSet="material-symbols-outlined">schedule</mat-icon>
      <span class="wr-hint-text">{{ regionHint }}</span>
    </div>

    <div class="wr-body">
      <ng-container *ngIf="isLanding; else selectedEmployee">
        <div class="wr-empty wr-empty--landing">
          <div class="wr-empty-title">Select an employee to load Work Replay</div>
          <div class="wr-empty-subtitle">Date defaults to yesterday.</div>
        </div>
      </ng-container>

      <ng-template #selectedEmployee>
        <div class="wr-timeline-shell">
          <div class="wr-summary-strip" *ngIf="!loadingScreenshots">
            <div class="wr-summary-card" *ngIf="conductActivityFilterCtrl.value !== 'untracked'">
              <div class="wr-summary-label">
                <span class="material-symbols-outlined wr-summary-ic">photo_library</span>
                Screenshots
              </div>
              <div class="wr-summary-value">{{ filteredScreenshots.length }}</div>
            </div>
            <div class="wr-summary-card"
              *ngIf="showConductLogsCtrl.value && conductActivityFilterCtrl.value === 'untracked'">
              <div class="wr-summary-label">
                <span class="material-symbols-outlined wr-summary-ic">pending_actions</span>
                Untracked Slots
              </div>
              <div class="wr-summary-value">{{ untrackedSlotsCount }}</div>
            </div>
            <div class="wr-summary-card">
              <div class="wr-summary-label"><span class="material-symbols-outlined wr-summary-ic">apps</span>Top app
              </div>
              <div class="wr-summary-value wr-summary-app">{{ topCapturedApp }}</div>
            </div>
            <div class="wr-summary-card">
              <div class="wr-summary-label"><span
                  class="material-symbols-outlined wr-summary-ic">schedule</span>Periodic</div>
              <div class="wr-summary-value">{{ getSummaryCountByType('periodic') }}</div>
            </div>
            <div class="wr-summary-card">
              <div class="wr-summary-label"><span class="material-symbols-outlined wr-summary-ic">swap_horiz</span>App
                switch</div>
              <div class="wr-summary-value">{{ getSummaryCountByType('app-changed') }}</div>
            </div>
            <div class="wr-summary-card">
              <div class="wr-summary-label"><span class="material-symbols-outlined wr-summary-ic">photo_camera</span>On
                demand</div>
              <div class="wr-summary-value">{{ getSummaryCountByType('admin-request') }}</div>
            </div>
            <div class="wr-summary-card" *ngIf="totalUsageFormatted !== '—'">
              <div class="wr-summary-label"><span class="material-symbols-outlined wr-summary-ic">bolt</span>Usage</div>
              <div class="wr-summary-value wr-summary-app">{{ totalUsageFormatted }}</div>
            </div>
            <div class="wr-summary-card" *ngIf="totalIdleFormatted !== '—'">
              <div class="wr-summary-label"><span class="material-symbols-outlined wr-summary-ic">coffee</span>Idle
              </div>
              <div class="wr-summary-value wr-summary-app">{{ totalIdleFormatted }}</div>
            </div>
          </div>

          <div class="wr-loading-row" *ngIf="loadingScreenshots || loadingLogs">
            <mat-progress-spinner diameter="22" mode="indeterminate" color="primary"
              class="wr-loading-spinner"></mat-progress-spinner>
            <span>Loading work replay…</span>
          </div>

          <div class="wr-empty" *ngIf="!loadingScreenshots && bucketGroups.length === 0">
            <div class="wr-empty-title" *ngIf="noResultAfterFilter; else noScreenshotsTitle">
              <ng-container
                *ngIf="showConductLogsCtrl.value && conductActivityFilterCtrl.value === 'untracked'; else defaultNoResults">
                No untracked activity found. All Conduct timelogs have corresponding screenshots.
              </ng-container>
              <ng-template #defaultNoResults>
                No results match current filters.
              </ng-template>
            </div>
            <ng-template #noScreenshotsTitle>
              <div class="wr-empty-title">No screenshots found for this employee on this date.</div>
            </ng-template>
            <div class="wr-empty-subtitle" *ngIf="noResultAfterFilter">
              Try changing filters or clearing search.
            </div>
          </div>

          <div class="wr-empty" *ngIf="!loadingScreenshots && noResultAfterDaypartFilter">
            <div class="wr-empty-title">No activity for {{ daypartFilterTriggerLabel | lowercase }} with current
              filters.</div>
            <div class="wr-empty-subtitle">Try another time of day or clear filters.</div>
          </div>

          <div class="wr-buckets wr-timeline" *ngIf="!loadingScreenshots && visibleBucketGroups.length">
            <ng-container *ngFor="let g of visibleBucketGroups">
              <div class="wr-step wr-step--section">
                <div class="wr-step-left">
                  <span class="material-symbols-outlined wr-section-icon">{{ getDaypartIcon(g.label) }}</span>
                </div>
                <div class="wr-step-right">
                  <button type="button" class="wr-daypart" (click)="toggleDaypart(g.label)">
                    <div class="wr-daypart-left">
                      <span class="wr-daypart-title">{{ g.label }}</span>
                    </div>
                    <div class="wr-daypart-right">
                      <span class="wr-daypart-chip">{{ g.bucketCount }} slots</span>
                      <span class="wr-daypart-chip wr-daypart-chip--primary">{{ g.screenshotCount }} screenshots</span>
                      <span class="material-symbols-outlined wr-daypart-chevron" aria-hidden="true">
                        {{ isDaypartCollapsed(g.label) ? 'expand_more' : 'expand_less' }}
                      </span>
                    </div>
                  </button>
                </div>
              </div>

              <div class="wr-step" *ngFor="let b of g.buckets; trackBy: trackBucket"
                [hidden]="isDaypartCollapsed(g.label)" [id]="'bucket-' + b.key">
                <div class="wr-step-left">
                  <span class="wr-node-dot" [ngClass]="getBucketStateDotClass(b)"></span>
                </div>
                <div class="wr-step-right">
                  <div class="wr-bucket-row" [class.wr-bucket-row--with-shots]="b.screenshots?.length">
                    <button type="button" class="wr-bucket-summary wr-bucket-summary--compact"
                      (click)="toggleBucket(b.key)" [attr.aria-expanded]="isBucketExpanded(b.key)"
                      [attr.aria-label]="(isBucketExpanded(b.key) ? 'Collapse' : 'Expand') + ' ' + b.label">
                      <div class="wr-bucket-left">
                        <div class="wr-bucket-time-row">
                          <span class="wr-bucket-label">{{ b.label }}</span>
                          <span class="wr-state-chip" [ngClass]="getBucketStateClass(b)">{{ getBucketStateLabel(b)
                            }}</span>
                          <span *ngIf="showConductLogsCtrl.value && b.conductTasks?.length" class="wr-conduct-pill"
                            (mouseenter)="onConductPillMouseEnter($event, b)" (mouseleave)="onConductPillMouseLeave()"
                            (click)="openConductDrawer($event)" title="Click to view Conduct timelogs drawer">
                            <mat-icon class="wr-conduct-pill-ic" fontSet="material-symbols-outlined">folder</mat-icon>
                            <span class="wr-conduct-pill-text">{{ getBucketConductSummary(b) }}</span>
                            <mat-icon class="wr-conduct-pill-open-ic"
                              fontSet="material-symbols-outlined">open_in_new</mat-icon>
                          </span>
                        </div>
                        <div class="wr-bucket-time-sub" *ngIf="getBucketTimeSummary(b)">
                          {{ getBucketTimeSummary(b) }}
                        </div>
                      </div>

                      <div class="wr-bucket-head-end">
                        <div class="wr-bucket-mid">
                          <div class="wr-bucket-mid-primary">{{ getBucketScreenshotCountText(b) }}</div>
                          <div class="wr-bucket-mid-secondary" *ngIf="getBucketSecondaryMeta(b)"
                            [attr.title]="getBucketSecondaryMeta(b)">
                            {{ getBucketSecondaryMeta(b) }}
                          </div>
                        </div>
                        <span class="wr-bucket-action" aria-hidden="true">
                          <span class="material-symbols-outlined wr-chevron">
                            {{ isBucketExpanded(b.key) ? 'expand_less' : 'expand_more' }}
                          </span>
                        </span>
                      </div>
                    </button>

                    <div class="wr-bucket-expanded" *ngIf="isBucketExpanded(b.key)">
                      <div class="wr-ss-grid" *ngIf="b.screenshots?.length">
                        <div class="wr-ss-card" *ngFor="let ss of b.screenshots; trackBy: trackScreenshot"
                          (click)="openScreenshotPreview(ss, b)">
                          <ng-container *ngIf="!ss._imgError && getScreenshotImageSrc(ss); else imageFallback">
                            <div class="wr-ss-media-frame">
                              <img class="wr-ss-img" [src]="getScreenshotImageSrc(ss)" loading="lazy"
                                (error)="onScreenshotImageError(ss)" />
                            </div>
                          </ng-container>
                          <ng-template #imageFallback>
                            <div class="wr-ss-img-fallback">
                              Screenshot image could not be loaded.
                            </div>
                          </ng-template>
                          <div class="wr-ss-meta">
                            <div class="wr-ss-meta-top">
                              <div class="ss-card-app wr-ss-meta-app">
                                <div class="ss-card-app-icon-wrap" aria-hidden="true">
                                  <img *ngIf="ss | screenIconGetter" class="ss-card-app-icon-img"
                                    [src]="ss | screenIconGetter" alt="" (error)="onAppIconError(ss)" />
                                  <mat-icon *ngIf="!(ss | screenIconGetter)" class="ss-card-app-icon-fallback"
                                    fontSet="material-symbols-outlined">{{ ss | appIconGlyph }}</mat-icon>
                                </div>
                                <div class="wr-ss-meta-app-text">
                                  <span class="ss-card-app-name wr-ss-app-title" [title]="ss.app_name || ''">{{
                                    (ss.app_name || 'Unknown app') | trimName }}</span>
                                  <span class="wr-ss-conduct-tag"
                                    *ngIf="showConductLogsCtrl.value && ss._conductProject"
                                    [title]="(ss._conductProject + (ss._conductTask ? ' · ' + ss._conductTask : '')) + ' (Click to open Conduct drawer)'"
                                    (click)="openConductDrawer($event)">
                                    <mat-icon class="wr-ss-conduct-tag-ic"
                                      fontSet="material-symbols-outlined">folder</mat-icon>
                                    <span class="wr-ss-conduct-tag-text">{{ ss._conductProject }}</span>
                                  </span>
                                  <div class="screenshot-time-compact wr-ss-time"
                                    *ngIf="!ss.showAbsoluteTime && ss.timeagoInput"
                                    [matTooltip]="ss.timeDisplay?.tooltip" matTooltipClass="screenshot-time-tooltip"
                                    matTooltipShowDelay="300" matTooltipPosition="above">
                                    <span class="screenshot-time-relative-sm">{{ ss.timeagoInput | timeago:true
                                      }}</span>
                                  </div>
                                  <div class="screenshot-time-compact wr-ss-time"
                                    *ngIf="ss.showAbsoluteTime || !ss.timeagoInput"
                                    [matTooltip]="ss.timeDisplay?.tooltip" matTooltipClass="screenshot-time-tooltip"
                                    matTooltipShowDelay="300" matTooltipPosition="above">
                                    <span class="screenshot-time-primary-sm">{{ ss.timeDisplay?.primaryAbsolute || '—'
                                      }}</span>
                                    <span class="screenshot-time-secondary-sm" *ngIf="ss.timeDisplay?.secondaryLine">{{
                                      ss.timeDisplay.secondaryLine }}</span>
                                  </div>
                                </div>
                              </div>
                              <div class="screenshot-type-chip wr-ss-type-chip" [ngClass]="getTriggerChipClass(ss.type)"
                                [ngSwitch]="ss.type">
                                <ng-container *ngSwitchCase="'app-changed'">
                                  <span class="material-symbols-outlined chip-ic">swap_horiz</span>
                                  <span>App switch</span>
                                </ng-container>
                                <ng-container *ngSwitchCase="'admin-request'">
                                  <span class="material-symbols-outlined chip-ic">photo_camera</span>
                                  <span>On demand</span>
                                </ng-container>
                                <ng-container *ngSwitchDefault>
                                  <span class="material-symbols-outlined chip-ic">schedule</span>
                                  <span>Periodic</span>
                                </ng-container>
                              </div>
                            </div>
                            <div class="wr-ss-meta-footer">
                              <div class="wr-ss-window"
                                *ngIf="ss._matchConfidence === 'exact_match' || ss._matchConfidence === 'near_match'; else noWindow"
                                [attr.title]="'Window: ' + (ss._windowName || '')">
                                Window: {{ ss._windowName }}
                              </div>
                              <ng-template #noWindow>
                                <div class="wr-ss-window wr-muted">Window details unavailable</div>
                              </ng-template>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="wr-slot-empty" *ngIf="!b.screenshots?.length">
                        <span class="wr-slot-empty-note">No screenshots captured in this slot.</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </ng-container>
          </div>

        </div>
      </ng-template>
    </div>
  </mat-card>

  <!-- Custom Conduct Tooltip Popover (Styled matching Timesheet, Employees Timeline & Apps/Website Usage) -->
  <div *ngIf="hoveredConductTooltipData" class="conduct-custom-popover"
    [class.popover-placement-top]="hoveredConductTooltipData.placement === 'top'"
    [class.popover-placement-bottom]="hoveredConductTooltipData.placement === 'bottom'"
    [style.left.px]="hoveredConductTooltipData.x" [style.top.px]="hoveredConductTooltipData.y" role="tooltip">

    <!-- Popover Caret Arrow -->
    <div class="popover-caret" [style.left.px]="hoveredConductTooltipData.caretOffset"></div>

    <!-- Header Section -->
    <div class="popover-header">
      <div class="popover-title-row">
        <div class="popover-title-wrap">
          <mat-icon class="popover-project-icon" fontSet="material-symbols-outlined">folder</mat-icon>
          <span class="popover-project-name" [title]="hoveredConductTooltipData.projectName">
            {{ hoveredConductTooltipData.projectName }}
          </span>
        </div>
        <span class="popover-total-badge">{{ hoveredConductTooltipData.slotLoggedTime }}</span>
      </div>
      <div class="popover-meta-row">
        <span class="popover-task-count">
          {{ hoveredConductTooltipData.tasksCount }} {{ hoveredConductTooltipData.tasksCount === 1 ? 'task' : 'tasks' }}
          logged in this slot
        </span>
      </div>
    </div>

    <!-- Mini Task Grid (aligned with Timesheet & Stacked Chart usage grid) -->
    <div class="popover-body" *ngIf="hoveredConductTooltipData.tasks?.length">
      <div class="popover-grid-wrap">
        <div class="popover-grid-head">
          <span>TASK</span>
          <span class="popover-col-duration">DURATION</span>
        </div>
        <div class="popover-grid-body">
          <div class="popover-grid-row" *ngFor="let task of hoveredConductTooltipData.tasks">
            <div class="popover-task-info">
              <span class="popover-task-title" [title]="task.taskTitle">{{ task.taskTitle }}</span>
              <span class="popover-task-time-range" *ngIf="task.timeRange">
                {{ task.timeRange }}
                <span *ngIf="task.totalWorkedHours && task.totalWorkedHours !== task.workedHours"
                  class="popover-task-total-hint">
                  ({{ task.totalWorkedHours }} total)
                </span>
              </span>
            </div>
            <span class="popover-task-time">{{ task.workedHours }}</span>
          </div>
        </div>
      </div>
      <div class="popover-more-tasks" *ngIf="hoveredConductTooltipData.moreCount > 0">
        +{{ hoveredConductTooltipData.moreCount }} more task{{ hoveredConductTooltipData.moreCount === 1 ? '' : 's' }}
      </div>
    </div>

    <!-- SuperSee Active Usage Comparison Footer & Drawer Link -->
    <div class="popover-footer" (click)="openConductDrawer($event)">
      <div class="popover-footer-usage" *ngIf="hoveredConductTooltipData.usageComparison">
        <mat-icon class="popover-footer-icon" fontSet="material-symbols-outlined">bolt</mat-icon>
        <span>SuperSee Active Usage: <strong>{{ hoveredConductTooltipData.usageComparison }}</strong></span>
      </div>
      <div class="popover-click-hint">
        <mat-icon class="popover-click-hint-ic" fontSet="material-symbols-outlined">touch_app</mat-icon>
        <span>Click to view Conduct timelogs drawer</span>
      </div>
    </div>
  </div>

  <!-- Conduct Timelogs Detail Drawer now hosted via centralized App Shared Drawer -->
</div>